import { render, staticRenderFns } from "./MedsosPopup.vue?vue&type=template&id=5dc928d7&scoped=true"
import script from "./MedsosPopup.vue?vue&type=script&lang=js"
export * from "./MedsosPopup.vue?vue&type=script&lang=js"
import style0 from "./MedsosPopup.vue?vue&type=style&index=0&id=5dc928d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc928d7",
  null
  
)

export default component.exports